import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
//import ReactDOM from "react-dom";
//import classNames from "classnames";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import Swal from "sweetalert2";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";
// import DNSPriceTable from "./common/DNSPriceTable";
//import Car from "../carbodyparts/car";
//import CarDentTable from "../carbodyparts/CarDentTable";
import { configuration } from "../appConfig";
import { calculatePrice } from "../pricing/calculatePrice";
//import SwissPriceTable from "./common/SwissPriceTable";
import SlovinaPriceTable from "./common/SlovinaPriceTable";
import CustomerInfoTable from "./common/CustomerInfoTable";
import "./dnsReportPrintMode.css";
import "./dnsReport.css";
import "./dnsReportResponsive.css";
import DuplicateVinModal from "./DuplicateVinModal";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class TabViewSL extends Component {
  state = {
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,

    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    swissTable: [],
    words: {},
    lang: "",
    duplicateVinModal: false,
    IsPriceTableUpdated: false,
    selectedPartnerIdList: [],
    selectedPartnerId: "",
    Authorized: false,
  };
  count = [];
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    // this.getData(selectedFile);
    this.vinFolderList();
    this.getLang();
    this.getOrderId();
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };
  getOrderId = () => {
    Axios.get(configuration.getData, {
      params: {
        vin: localStorage.getItem("selectedFile"),
        partnerId: localStorage.getItem("partnerId"),
      },
    })
      .then((res) => {
        this.setState({
          Authorized: res.data.Authorized,
          IsPriceTableUpdated: res.data.IsPriceTableUpdated || false,
        });
      })
      .catch((err) => console.log(err));
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
      // this.props.history.push('/login');
      // alert('No Partner Id selected! Please login.')
    }
  };

  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId
      );

      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
        response.data[0].resultTXT.scanresult &&
          this.countDetails(response.data[0].resultTXT.scanresult);
      } else {
        // alert('Data not available.')
      }
    } else {
      this.props.history.push("/login");
    }
  };
  countDetails = async (rowArray) => {
    let promises = [];
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    for (let i = 0; i < rowArray.length; i++) {
      // if (rowArray[i].Amount) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        vin +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i].part;
      //promises.push(url);
      promises.push(Axios.get(url));
      // }
    }

    const arrRes = await Axios.all(promises);

    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");

      // let gtt = val.map(r => {
      //   let val2 = r.split(" ")[3];

      //   if (val2 && parseInt(val2) > 25) {
      //     ltcount = ltcount + 1;
      //     return val2;
      //   }

      // });
      // let ltt = val.map(r => {
      //   let val2 = r.split(" ")[3];

      //  if (val2 && parseInt(val2) < 26) {
      //     ltcount = ltcount + 1;
      //     return val2;
      //   }
      //   //return val2;
      // });

      // return { part: result.data.part,count:val.length-1, lt25: ltt.filter( Boolean ).length, gt25: gtt.filter( Boolean ).length };

      val.map((r) => {
        let val2 = r.split(" ")[3];

        if (val2 && parseInt(val2) > 25) {
          gtcount = gtcount + 1;
        }
        if (val2 && parseInt(val2) < 26) {
          ltcount = ltcount + 1;
        }
        return val2;
      });

      return {
        part: result.data.part,
        count: val.length - 1,
        lt25: ltcount,
        gt25: gtcount,
        ltunit: calculatePrice(24, ltcount),
        gtunit: calculatePrice(26, gtcount),
      };
    });
    this.setState({ swissTable: ltgtdata });
    //    console.table(ltgtdata);
    //return 5
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    //this.getData(this.state.selectedFile);
    this.customerInfo();
  };

  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };
  change = (val, index) => {
    //
    const { scanresult } =
      this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;

    scanresult[index].size = val;
    this.setState({ scanresult });
    const result = window.confirm("Are you sure want to change Size?");
    if (result) {
      const url = configuration.Update_ResultTxt;
      let payload = {
        scanresult: scanresult,
        partnerId: localStorage.getItem("partnerId"),
        vin: localStorage.getItem("selectedFile"),
      };
      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
      });
    }
  };
  handleChange = (row, value, index) => {
    if (value > 0) {
      row.size = value;
      //let dd = this.state.vinfolderList[0].resultTXT.scanresult[index];
      this.setState({ dd: row });
    }
  };
  changeCount = (row, value, index) => {
    if (value >= 0) {
      row.Amount = value;
      //  let countRow = this.state.vinfolderList[0].resultTXT.scanresult[index];
      this.setState({ countRow: row });
    }
  };
  Update = () => {
    const url = configuration.Update_ResultTxt;
    let data = this.state.vinfolderList[0].resultTXT;
    data.partnerId = localStorage.getItem("partnerId");

    Axios.post(url, data).then((res) => {
      alert("data updated");
    });
  };

  handleRestoreJson = () => {
    this.setState({
      restoreDataloading: true,
    });
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    let url = `${configuration.restoreJsonBackup}?partnerId=${partnerId}&vin=${vin}`;
    Axios.get(url)
      .then((res) => {
        if (res.data.status === 200) {
          Toast.fire({
            type: "success",
            title: "JSON restored successfully!",
          });
          this.setState({
            restoreDataloading: false,
          });
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        } else if (res.data.status === 400) {
          this.setState({
            restoreDataloading: false,
          });
          Toast.fire({
            type: "error",
            title: "Failed to restore JSON!",
          });
        } else if (res.data.status === 404) {
          this.setState({
            restoreDataloading: false,
          });
          Toast.fire({
            type: "error",
            title: "JSON backup not found!",
          });
        }
      })
      .catch((err) => {
        this.setState({
          restoreDataloading: false,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      });
  };
  openDuplicateVinModal = (clearValue) => {
    this.setState({ duplicateVinModal: !this.state.duplicateVinModal });
    if (clearValue) {
      this.setState({selectedPartnerId : ""})
    }
    if (
      this.props.selectedPartnerId &&
      this.props.selectedPartnerId.length > 0
    ) {
      const newOptions = this.props.selectedPartnerId.map((val) => ({
        label: val,
        value: val,
      }));

      this.setState({ selectedPartnerIdList: newOptions });
    }
  };

  handleSelectedPartnerId = (selectedOptions) => {
    this.setState({ selectedPartnerId: selectedOptions });
  };

  render() {
    //const selectedFile = localStorage.getItem("selectedFile");

    const { orderNumber } = this.state.order;
    const showDuplicateVinBtn = this.props.isDuplicateVin == 1 ? true : false;

    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT &&
      scanResult.resultTXT.scanresult &&
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });
    const {
      Authorized,
      IsPriceTableUpdated,
      duplicateVinModal,
      selectedPartnerIdList,
      selectedPartnerId,
    } = this.state;
    //const dentInfo = scanResult.resultTXT;
    const userSession = localStorage.getItem("userSession");
    const data = userSession ? JSON.parse(userSession) : {};
    return (
      <div className="animated fadeIn">
        <Col xs="12" sm="12" className="p-2">
          <Card className="print_button_card">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-4 col-sm-6 col-6 mt-sm-10">
                    <small>
                      {" "}
                      <span>{this.lang("VIN Number")} :</span>{" "}
                      {localStorage.getItem("selectedFile")}
                    </small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-6 col-6 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      {showDuplicateVinBtn && (
                        <button
                          disabled={Authorized || !IsPriceTableUpdated}
                          className="glass btn mx-3 btn-lg btn-danger mr-1"
                          onClick={() => this.openDuplicateVinModal()}
                        >
                          {this.lang("Duplicate VIN")}
                        </button>
                      )}
                      <button
                        className="glass btn mx-3 btn-lg btn-danger pull-right mr-1"
                        onClick={() => this.handleRestoreJson()}
                        disabled={Authorized}
                      >
                        {this.lang("Restore Data")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <Card>
            {/* <CardHeader> */}
            {/* <Link className="glass" to="/ReportMini">
                <button className="btn btn-danger btn-sm pull-right">
                  <i className="fa fa-dot-circle-o"></i> {">>"}
                </button>
              </Link>

              <Link className="glass" to="/vehicleDentInfo">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-right"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
              </Link> */}
            {/* <small className="pull-right rightLbl"> */}
            {/* Order No : {orderNumber} */}
            {/* </small> */}
            {/* <small>
                {" "}
                VIN Number : {localStorage.getItem("selectedFile")} &nbsp;
              </small> */}
            {/* </CardHeader> */}
            <CardBody>
              <div className="">
                <div className="d-list-middle col-12 col-md-12 p-0">
                  <CustomerInfoTable viewType="TabView" />
                </div>
                {/* <DNSPriceTable is_extra_columns_visible={true} /> */}
                <SlovinaPriceTable
                  is_extra_columns_visible={true}
                  viewType="TabView"
                />
              </div>
            </CardBody>

            <div className="card-footer">
              {/* <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  this.Update();
                }}
              >
                Update
              </button> */}

              {/* <Link className="glass" to="/ReportMini">
                <button className="btn btn-danger btn-sm pull-right">
                  <i className="fa fa-dot-circle-o"></i> {">>"}
                </button>
              </Link>

              <Link className="glass" to="/vehicleDentInfo">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-right"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
              </Link> */}
            </div>
          </Card>
        </Col>
        <DuplicateVinModal 
        duplicateVinModal={duplicateVinModal}
        openDuplicateVinModal={this.openDuplicateVinModal}
        selectedPartnerIdList={selectedPartnerIdList}
        handleSelectedPartnerId={this.handleSelectedPartnerId}
        selectedPartnerId={selectedPartnerId}
        lang={this.lang}
        />
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    selectedPartnerId: props.selectedPartnerId.duplicateSelectedPartnerId,
    isDuplicateVin: props.selectedPartnerId.isDuplicateVin,
  };
};
export default compose(connect(mapStateToProps), withRouter)(TabViewSL);
